/* unplugin-vue-components disabled */import script from "./SvgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgIcon.vue?vue&type=script&setup=true&lang=ts"

import "./SvgIcon.vue?vue&type=style&index=0&id=19679dbe&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\home-power-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19679dbe"]])

export default __exports__